(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/game-handler.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/game-handler.js');
"use strict";


if (svs.utils.ns.isNamespace('svs.gameHandler.data.games')) {
  const {
    getPackageGameConfig
  } = svs.ticketgames.gameHandler.helpers;
  const {
    mapScratchTicketsFromContentList
  } = svs.ticketgames.gameHandler;
  const {
    packageGameConfig,
    cntTicketGames = []
  } = svs.gameHandler.data.games;
  const games = mapScratchTicketsFromContentList([], cntTicketGames, [], svs.core.detect.feature('ft-soft-launch-ticket'));
  setGlobal('svs.ticketgames.gameHandler.getPackageGame', function () {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : packageGameConfig;
    let allGames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : games;
    return getPackageGameConfig(config, allGames);
  });
}

 })(window);